import React, { useState } from "react";
import { FaMoneyBill } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

import ReusableModal from "../../shared/ReuseableModal";
import CustomChip from "../../shared/CustomChip";
import PayVisitBillForm from "../../components/his/visits/PayVisitBillForm";
import { useTranslation } from "react-i18next";
import DepositForm from "./depost/DepositForm";
import WithdrawDepositForm from "./depost/WithdrawDepositForm";
import PayCreditForm from "./depost/PayCreditForm";
import CreateVisitWithoutSlot from "../../components/his/visits/CreateVisitWithoutSlot";

const CreateWithoutSlot = () => {
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const billingVisitData = state?.billingVisitData || null;
  const orderData = state?.orderData || null;
  const [openDepositForm, setOpenDepositForm] = useState(false);
  const [openWithdrawDepositForm, setOpenWithdrawDepositForm] = useState(false);
  const [openPayCreditForm, setOpenPayCreditForm] = useState(false);
  const [refreshDepositTrigger, setRefreshDepositTrigger] = useState(0);
  const [refreshCreditTrigger, setRefreshCreditTrigger] = useState(0);
  const [openVisit, setOpenVisit] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [eligibilityData, setEligibilityData] = useState(null);
  const [selctedPatient, setSelctedPatient] = useState(
    location?.state?.patientData?.file_no || ""
  );
  const [patientDoc, setPatientDoc] = useState(
    location?.state?.patientData?.document_id || ""
  );

  const { t } = useTranslation();
  const [selectedPatient, setSelectedPatient] = useState("");

  const handlePatientOrderSearch = patientData => {
    navigate('/patient-active-orders', {
      state: {
        patientData
      }
    });
  };

  return (
    <div className="main-page-container !overflow-y-auto scrollbar !py-0">
      <div className="w-full">
        <div className="flex lg:items-start lg:justify-between flex-col lg:flex-row gap-y-2 lg:gap-y-0  mb-2">
          {/* <div className="flex items-center">
            {location?.pathname !== "/create-visit-without-slot" && (
              <FaArrowCircleLeft
                className="text-primary me-2 cursor-pointer"
                size={20}
                onClick={() => navigate(-1)}
              />
            )}
            <h3 className="text-darkBg w-[180px]  text-[16px] md:text-[18px] lg:text-[20px] font-[600]">
              {billingVisitData ? t("PayBill") : t("CreateNewVisit")}
            </h3>
          </div> */}
        </div>

        {billingVisitData ? (
          <PayVisitBillForm
            setSelectedPatient={setSelectedPatient}
            selectedPatient={selectedPatient}
            refreshCreditTrigger={refreshCreditTrigger}
          />
        ) : (
          <CreateVisitWithoutSlot
            setOpenVisit={setOpenVisit}
            selctedPatient={selctedPatient}
            setSelctedPatient={setSelctedPatient}
            handlePatientSelectMain={handlePatientOrderSearch}
            eligibilityData={eligibilityData}
            setOpenDepositForm={setOpenDepositForm}
            setOpenWithdrawDepositForm={setOpenWithdrawDepositForm}
            setOpenPayCreditForm={setOpenPayCreditForm}
            setShowComments={setShowComments}
            showComments={showComments}
            visit_category="out_patient"
            setEligibilityData={setEligibilityData}
            setSelectedPatient={setSelectedPatient}
            openVisit={openVisit}
            openDepositForm={openDepositForm}
            selectedPatient={selectedPatient}
            refreshCreditTrigger={refreshCreditTrigger}
            refreshDepositTrigger={refreshDepositTrigger}
            patientDoc={patientDoc}
            setPatientDoc={setPatientDoc}
            orderData={orderData}
          />
        )}
        <ReusableModal
          title={`${t("Deposit Form")}`}
          isVisible={openDepositForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenDepositForm(false);
          }}
        >
          <DepositForm
            selectedPatient={selectedPatient}
            setOpenDepositForm={setOpenDepositForm}
            withOutSlot={true}
            state={state}
            onDepositSuccess={() => setRefreshDepositTrigger(prev => prev + 1)}
          />
        </ReusableModal>
        <ReusableModal
          title={`${t("Withdraw Deposit Form")}`}
          isVisible={openWithdrawDepositForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenWithdrawDepositForm(false);
          }}
        >
          <WithdrawDepositForm
            selectedPatient={selectedPatient}
            setOpenWithdrawDepositForm={setOpenWithdrawDepositForm}
            withOutSlot={true}
            state={state}
            onWithdrawSuccess={() => setRefreshDepositTrigger(prev => prev + 1)}
          />
        </ReusableModal>
        <ReusableModal
          title={`${t("Pay Credit")}`}
          isVisible={openPayCreditForm}
          HeaderIcon={FaMoneyBill}
          position="top"
          onClose={() => {
            setOpenPayCreditForm(false);
          }}
        >
          <PayCreditForm
            selectedPatient={selectedPatient}
            setOpenPayCreditForm={setOpenPayCreditForm}
            state={state}
            onPayCreditSuccess={() => setRefreshCreditTrigger(prev => prev + 1)}
            withOutSlot={true}
          />
        </ReusableModal>
        {/* Patient active orders now live on /patient-active-orders. */}
      </div>
    </div>
  );
};

export const EligibilityDataComponent = ({
  eligibilityData,
  referralEligible = false
}) => {
  let siteEligibility =
    eligibilityData?.nphies_entries?.CovElgResp?.resource?.extension?.[0]
      ?.valueCodeableConcept?.coding?.[0]?.code;
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-stretch h-full w-full min-h-[45px]'>
      <span className='input-label block !text-start !mb-1 !w-full'>
        {t('Eligibility')}
      </span>
      <div className='h-[28px] flex items-center justify-center w-full'>
        <CustomChip
          label={referralEligible ? t('eligible') : siteEligibility || "---"}
          className='!h-full !px-3 !rounded-md !w-full'
          chipType={
            referralEligible || siteEligibility === 'eligible'
              ? 'success'
              : eligibilityData?.nphies_status === 'error' ||
                siteEligibility === 'not-active'
                ? 'danger'
                : 'default'
          }
        />
      </div>
    </div>
  );
};

export default CreateWithoutSlot;
